// extracted by mini-css-extract-plugin
export default {"wrap":"pu-z","fullWidth":"qu-z","items":"ru-z","featureCss":"su-z","disabled":"tu-z","imgCss":"uu-z"};